import { render, staticRenderFns } from "./CustomerServiceStat.vue?vue&type=template&id=51a42d60&"
import script from "./CustomerServiceStat.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceStat.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceStat.vue?vue&type=style&index=0&id=51a42d60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports